import { useAppSelector } from "@/hooks/use-state";
import { Loader2 } from "lucide-react";
import { Redirect, Route, RouteComponentProps  } from "wouter";
import { selectAuthLoading, selectUser, selectMenuMap } from "@/features/auth/authSlice";
import NotAuthorized from "@/modules/common/not-authorized";

interface ProtectedRouteProps {
  path: string;
  moduleKey: string;
  component: React.ComponentType<RouteComponentProps>;
}


export function ProtectedRoute({ path, moduleKey, component: Component }: ProtectedRouteProps) {
  const user = useAppSelector(selectUser);
  const menuMap = useAppSelector(selectMenuMap);
  const isLoading = useAppSelector(selectAuthLoading);
  
  if (isLoading) {
    return (
      <Route path={path}>
        <div className="flex items-center justify-center min-h-screen">
          <Loader2 className="h-8 w-8 animate-spin text-[var(--color-primary)]" />
        </div>
      </Route>
    );
  }

  if (!user || !menuMap) {
    return (
      <Route path={path}>
        <Redirect to="/auth" />
      </Route>
    );
  }

  const currentMenu = menuMap[moduleKey];
  const hasAccess = Boolean(currentMenu);

  if(!hasAccess){
    return (
      <Route path={path}>
        <NotAuthorized />
      </Route>
    );
  }
    
  return <Route path={path} component={Component} />;
}
